import React from 'react';

import { css } from 'glamor';

export default function DesktopOnly({ children }: { children: React.Element }) {
  return (
    <div
      {...css({
        display: 'none',
        '@media (min-width: 701px)': { display: 'block' },
      })}>
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ../src/client/components/layout/DesktopOnly.js